export enum WorkingHoursMode {
  SameEveryDay = "SameEveryDay",
  PerDay = "PerDay",
}
